import React from 'react';
import './index.css';
import { initSentry } from './lib/sentry';
import { render } from 'react-dom';
import { App } from './App';

initSentry();
// Register service worker for PWA support (offline caching + installability).
if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.
    register('/sw.js', {
      scope: '/'
    }).
    catch((err) => {
      console.warn('[PWA] Service worker registration failed:', err);
    });
  });
}
// Link the manifest at runtime — works regardless of build pipeline.
if (typeof document !== 'undefined') {
  const existing = document.querySelector('link[rel="manifest"]');
  if (!existing) {
    const link = document.createElement('link');
    link.rel = 'manifest';
    link.href = '/manifest.json';
    document.head.appendChild(link);
  }
  // Theme color for the browser chrome / iOS status bar
  if (!document.querySelector('meta[name="theme-color"]')) {
    const meta = document.createElement('meta');
    meta.name = 'theme-color';
    meta.content = '#0F3D5C';
    document.head.appendChild(meta);
  }
  // iOS web app capable
  if (!document.querySelector('meta[name="apple-mobile-web-app-capable"]')) {
    const meta = document.createElement('meta');
    meta.name = 'apple-mobile-web-app-capable';
    meta.content = 'yes';
    document.head.appendChild(meta);
  }
}
render(<App />, document.getElementById('root'));